module.exports = __webpack_public_path__ + "media/images/category_icons/category_icon_1-abc500c50990bd8810644b8cdbfe4c47.svg";